export default __webpack_public_path__ + "static/Greycliffcf-medium-webfont-7c3bbefce1e898f7a58e571b0312c614.woff2";